var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H9v5H6l6 6 6-6h-3V1zM21 19v-8l-9 3.5V23l9-4z",
    fill: "var(--sidebar-icon-accent, #ADC9FF)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10l-3 1 6.5 2.5L6 10zM18 10l3 1-6.5 2.5L18 10z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 1c0-.345.28-.625.625-.625h6c.345 0 .625.28.625.625v4.375H18a.625.625 0 01.442 1.067l-6 6a.625.625 0 01-.884 0l-6-6A.625.625 0 016 5.375h2.375V1zm1.25.625V6c0 .345-.28.625-.625.625H7.509L12 11.116l4.491-4.491H15A.625.625 0 0114.375 6V1.625h-4.75zM2.718 10.587a.5.5 0 01.463-.053l9 3.5a.5.5 0 01.319.466V23a.5.5 0 01-.703.457l-9-4A.5.5 0 012.5 19v-8a.5.5 0 01.218-.413zm.782 1.144v6.944l8 3.556v-7.389l-8-3.111z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.282 10.587A.5.5 0 0121.5 11v8a.5.5 0 01-.297.457l-9 4A.5.5 0 0111.5 23v-8.5a.5.5 0 01.319-.466l9-3.5a.5.5 0 01.463.053zM12.5 14.842v7.389l8-3.556v-6.944l-8 3.111zM5.842 9.526a.5.5 0 01.512.12l3.5 3.5a.5.5 0 01-.533.82l-6.5-2.5a.5.5 0 01.02-.94l3-1zM4.48 11.034l3 1.153-1.615-1.615-1.385.462z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.158 9.526a.5.5 0 00-.512.12l-3.5 3.5a.5.5 0 00.534.82l6.5-2.5a.5.5 0 00-.022-.94l-3-1zm1.362 1.508l-3 1.153 1.615-1.615 1.385.462z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/media/collect.6dfa25b1e1a3b8e78b16db71e37acb91.svg";
export { ForwardRef as ReactComponent };